<div class="star-label">
	<typography variant="p/xs_regular" class="rating-number">
		{{ rating }}
	</typography>
	<span class="star">★</span>
</div>
<div class="track">
	<div class="fill" [style.width.%]="barPercentage"></div>
</div>
<typography variant="p/xs_regular" class="count-label">
	{{ formattedCount }}
</typography>
